<template>
  <v-container fluid class="bankaccount-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-bankaccount`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Account
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-statements`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Statements
          </v-tab>
          <!-- <v-tab
            class="mr-5"
            :href="`#tab-notices`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Notices
          </v-tab> -->
          <v-tab-item
            :value="'tab-bankaccount'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <p class="text-h5">Edit Account</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeBankAccount($event, 'accountcode')"
                        v-bind:value="initvalue.accountcode"
                        placeholder="Bank Account Code"
                        persistent-hint
                        single-line hint="Enter the account code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeBankAccount($event, 'accountname')"
                        v-bind:value="initvalue.accountname"
                        placeholder="Bank Account Name"
                        persistent-hint
                        single-line hint="Enter the account name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=accounttype
                        :value="initvalue.accounttype"
                        outlined
                        dense
                        v-on:change="onChangeBankAccount($event, 'accounttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the account type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.accountstatus"
                        v-on:change="onChangeBankAccount($event, 'accountstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        outlined
                        dense
                        class="mb-4"
                        :items="accounts.filter(account=>account.accountsubclass=='Bank').map(x => {
                          return {text: x.accountname, value: x._id};
                        })"
                        :value="initvalue.accountid"
                        v-on:change="onChangeBankAccount($event, 'accounttype')"
                        v-bind:error="errorindex == 3"
                        placeholder="Account"
                        persistent-hint
                        single-line hint="Please choose the account">
                      </v-select>
                      <v-menu
                        ref="menu_accountstartdate"
                        v-model="menu_accountstartdate"
                        :close-on-content-click="false"
                        :return-value.sync="accountstartdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="accountstartdate"
                            label="Opening Date"
                            v-bind="attrs"
                            v-bind:value="accountstartdate"
                            v-on:change="
                              onChangeBankAccount($event, 'accountstartdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please enter account open date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="accountstartdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_accountstartdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBankAccount(
                                accountstartdate,
                                'accountstartdate'
                              );
                              $refs.menu_accountstartdate.save(accountstartdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_accountenddate"
                        v-model="menu_accountenddate"
                        :close-on-content-click="false"
                        :return-value.sync="accountenddate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="accountenddate"
                            label="Closing Date"
                            v-bind="attrs"
                            v-bind:value="accountenddate"
                            v-on:change="
                              onChangeBankAccount($event, 'accountenddate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please enter account close date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="accountenddate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_accountenddate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBankAccount(
                                accountenddate,
                                'accountenddate'
                              );
                              $refs.menu_accountenddate.save(accountenddate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-form>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/bankaccount/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editBankAccountRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-statements'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Statements</p>
                      </v-col>
                      <v-col md="6" align=right>
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddStatement = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="success"
                          to="/bankaccount/list"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="statementdate"
                        sort-desc
                        :headers="header_statements"
                        :footer-props="footer"
                        :items="bankstatements"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteStatement" width="500">
                            <v-card>
                              <v-card-title> Delete this Statement? </v-card-title>
                              <v-card-text>
                                {{ delete_statement.statementname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteStatement = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteBankStatement(delete_statement)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.statementname="{ item }">
                          <p class="two-line">{{ item.statementname }}</p>
                        </template>
                        <template v-slot:item.statementbalance="{ item }">
                          {{ item.statementbalance!=null ? item.statementbalance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}
                        </template>
                        <template v-slot:item.statementfile="{ item }">
                            <a v-if="item.statementfile!=''" :href="item.statementfile" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.statementdate="{ item }">
                          {{
                            new Date(item.statementdate).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editStatementDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteBankStatementDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddStatement"
      persistent
      width="600px"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Statement</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                    <v-menu
                      ref="new_statementdate"
                      v-model="new_statementdate"
                      :close-on-content-click="false"
                      :return-value.sync="add_statement.statementdate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_statement.statementdate"
                          label="Statement Date"
                          v-bind="attrs"
                          v-bind:value="add_statement.statementdate"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose statement date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_statement.statementdate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_statementdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_statementdate.save(add_statement.statementdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="add_statement.statementname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  dense
                  v-model="add_statement.statementbalance"
                  label="Ending Balance"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input dense label="File input" v-model="new_statementfile" v-on:change="onChangeStatementFile" accept=".pdf" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddStatement=false; add_statement={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addBankStatementRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditStatement"
      persistent
      width="600px"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Statement</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                    <v-menu
                      ref="edit_statementdate"
                      v-model="edit_statementdate"
                      :close-on-content-click="false"
                      :return-value.sync="edit_statement.statementdate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="edit_statement.statementdate"
                          label="Statement Date"
                          v-bind="attrs"
                          v-bind:value="edit_statement.statementdate"
                          v-on:change="onChangeStatement($event, 'statementdate')"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose statement date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="edit_statement.statementdate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="edit_statementdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            onChangeStatement(
                              edit_statement.statementdate,
                              'statementdate'
                            );
                            $refs.edit_statementdate.save(edit_statement.statementdate);"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="edit_statement.statementname"
                  v-on:change="onChangeStatement($event, 'statementname')"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  dense
                  v-model="edit_statement.statementbalance"
                  v-on:change="onChangeStatement($event, 'statementbalance')"
                  label="Ending Balance"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input dense label="File input" v-model="new_statementfile" v-on:change="onChangeStatementFileEdit" accept=".pdf" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditStatement = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editStatementRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
  </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";
import { formatStdDate } from '@/mixins/date';

export default {
  data () {
    return {
      header_statements: [
        { text: "File", value: "statementfile", width: "10%" },
        { text: "Date", value: "statementdate", width: "10%"},
        { text: "Name", value: "statementname" },
        { text: "Balance", value: "statementbalance", width: "20%"},
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      bankaccount: {},
      bankstatements: [],
      banknotices: [],


      bankaccountchannels: [],
      bankaccountitems: [],
      accounttype: ['Bank Account', 'Other Bank Account'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      accountstartdate: null,
      accountenddate: null,
      menu_accountstartdate: false,
      menu_accountenddate: false,

      new_statementdate: null,
      edit_statementdate: null,
      new_statementfile: null,
      edit_statementfile: null,

      add_statement: {},
      add_notice: {},

      add_item: {},
      add_channel: {},
      edit_statement: {},
      edit_subgroup: {},
      edit_item: {},
      edit_channel: {},
      change_bankaccount: {},
      change_statement: {},
      change_subgroup: {},
      change_item: {},
      change_channel: {},
      delete_statement: {},
      delete_subgroup: {},
      delete_item: {},
      delete_channel: {},
      isDeleteStatement: false,
      isDeleteSubgroup: false,
      isDeleteItem: false,
      isDeleteChannel: false,
      isAddStatement: false,
      isAddSubgroup: false,
      isAddItem: false,
      isAddChannel: false,
      isEditStatement: false,
      isEditSubgroup: false,
      isEditItem: false,
      isEditChannel: false,
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
    }
  },
  computed: {
    ...mapState('BankAccount', ['isReceiving']),
    ...mapState('Account', ['accounts'])
  },
  methods: {
    ...mapActions('BankAccount', 
    [ 'getBankAccountsRequest',
      'deleteBankStatementRequest', 'deleteBankAccountSubgroupRequest', 'deleteBankAccountItemRequest',
      'insertBankStatementRequest', 'insertBankStatementWithFileRequest', 'insertBankAccountItemRequest',
      'updateBankAccountRequest','updateBankStatementRequest','updateBankAccountSubgroupRequest','updateBankAccountItemRequest' 
    ]),
    ...mapActions('Account', ['getAccountsRequest']),
    async addBankStatementRequest() {
      this.isAddStatement = false;
      this.add_statement.id = this.initvalue._id;
      let result;
      if(this.add_statement.imagefile!=null) result = await this.insertBankStatementWithFileRequest(this.add_statement);
      else result = await this.insertBankStatementRequest(this.add_statement);
      this.bankstatements.push(result);
      this.add_statement = {};
    },
    deleteBankStatementDialog(item) {
      this.isDeleteStatement = true;
      this.delete_statement = {
        _id: item._id,
        statementname: item.statementname,
      };
    },
    async deleteBankStatement(payload) {
      this.isDeleteStatement = false;
      let response = await this.deleteBankStatementRequest(payload);
      let index = this.bankstatements.findIndex((trans) => trans._id == response._id);
      this.bankstatements.splice(index, 1);
    },
    editStatementDialog(item) {
      this.edit_statement = Object.assign({}, item);
      this.edit_statement.statementdate = formatStdDate(this.edit_statement.statementdate);
      this.change_statement = {};
      this.isEditStatement = true;
    },
    async editBankAccountRequest() {
      this.change_bankaccount._id = this.initvalue._id;
      await this.updateBankAccountRequest(this.change_bankaccount);
      router.push('/bankaccount/list');
    },
    async editStatementRequest() {
      this.isEditStatement = false;
      this.change_statement.id = this.edit_statement._id;
      let response = await this.updateBankStatementRequest(this.change_statement);
      let index = this.bankstatements.findIndex((item) => item._id == response._id);
      this.bankstatements.splice(index, 1, response);
      this.edit_statement = {};
      this.change_statement = {};
    },
    onChangeBankAccount(value, field){
      this.change_bankaccount[field] = value;
    },
    onChangeStatementFile(file) {
      if (!file) return;
      this.add_statement.imagefile = file;
      this.add_statement.imagename = file.name;
    },
    onChangeStatementFileEdit(file) {
      if (!file) return;
      this.change_statement.imagefile = file;
      this.change_statement.imagename = file.name;
    },
    onChangeStatement(value, field){
      this.change_statement[field] = value;
    },     
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'BankAccountList' });
    this.accountstartdate = formatStdDate(this.initvalue.accountstartdate);
    this.accountenddate = formatStdDate(this.initvalue.accountenddate);

    this.bankstatements = this.initvalue.statements;

    if(this.accounts.length==0) await this.getAccountsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
